import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            As a second-generation financial advisor, I, Rushi Kalpeshkumar
            Shah, have grown up witnessing the positive impact of comprehensive
            financial planning on individuals and families. Inspired by my
            father's legacy, Kalpesh Kanubhai Shah, a renowned financial advisor
            with over 35 years of experience, I have joined the family tradition
            of helping people achieve their financial aspirations. With a modern
            approach and fresh perspective, I aim to carry forward the values of
            trust, expertise, and personalized service that have defined our
            family's practice. I am committed to continuing my education and
            staying up-to-date on industry trends to provide innovative
            solutions for our clients. Together with my father, I am dedicated
            to building long-term relationships and making a meaningful
            difference in the financial lives of those we serve.
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
